import { render, staticRenderFns } from "./NextAppointmentDateForm.vue?vue&type=template&id=96c8aba4&"
import script from "./NextAppointmentDateForm.vue?vue&type=script&lang=js&"
export * from "./NextAppointmentDateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports